import SimpleCrypto from "simple-crypto-js";
import fernet from "fernet";

const encryptInit = new SimpleCrypto(
  process.env.REACT_APP_LOCAL_STORAGE_ENCRYPTION_KEY
);
const decrypt = (token) => {
  let data;
  try {
    data = new fernet.Token({
      secret: new fernet.Secret(
        encryptInit.decrypt(process.env.REACT_APP_DATA_SECRET_KEY)
      ),
      token,
      ttl: 0,
    });
    data = JSON.parse(data.decode());
  } catch (err) {
    data = { errored: true, message: err.message };
  }
  // console.log(data);
  return data;
};
export default decrypt;
